module.exports = __webpack_public_path__ + "static/media/pen3.5a8ef6d6.jpg";